<template>
    <div class="flex w-full items-center justify-center" :class="props.class">
        <div :class="containerClass">
            <slot name="icon">
                <!-- Default icon -->
                <div
                    :class="iconClass"
                >
                    <svg :class="svgClass" viewBox="0 0 24 24">
                        <path
                            d="M19 3H5a2 2 0 00-2 2v14c0 1.103.897 2 2 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H5V5h14v14z"
                        />
                        <path
                            d="M7 7h10v2H7zm0 4h7v2H7zm0 4h10v2H7z"
                            class="text-slate-400"
                        />
                    </svg>
                </div>
            </slot>

            <h2 :class="titleClass">{{ title }}</h2>
            <div :class="messageClass">{{ message }}</div>

            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    message: {
        type: String,
        required: true,
    },
    variant: {
        type: String,
        default: 'default',
    },
    class: {
        type: null,
        default: '',
    },
})

const isCompact = computed(() => props.variant === 'compact')
const containerClass = computed(() => (isCompact.value ? 'max-w-sm px-3 text-center' : 'mt-16 max-w-2xl px-4 text-center'))
const iconClass = computed(() =>
    isCompact.value
        ? 'mb-2 inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-100'
        : 'mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-t from-slate-200 to-slate-100',
)
const svgClass = computed(() =>
    isCompact.value ? 'h-4 w-4 fill-current text-slate-500' : 'h-6 w-6 fill-current text-slate-500',
)
const titleClass = computed(() =>
    isCompact.value ? 'mb-1 text-sm font-semibold text-slate-800' : 'mb-2 text-2xl font-bold text-slate-800',
)
const messageClass = computed(() => (isCompact.value ? 'text-xs text-slate-500' : 'mb-6 text-slate-600'))
</script>
